// Quiz "Quelle Théière pour Vous"
// Scoring par collection + filtre par budget + recommandation top 3

(function () {
  'use strict';

  const PRICE_RANGES = {
    low: { min: 0, max: 4000 },         // < 40 €  (en cents Shopify)
    mid: { min: 0, max: 8000 },         // 40-80 €
    high: { min: 0, max: 15000 },       // 80-150 €
    premium: { min: 0, max: 99999900 }  // no limit
  };

  // === Mapping collection key -> handles à matcher dans les données produits ===
  const COLLECTION_MAPPING = {
    fonte: ['theiere-en-fonte'],
    verre: ['theiere-en-verre'],
    ceramique: ['theiere-ceramique'],
    porcelaine: ['theiere-en-porcelaine'],
    inox: ['theiere-inox'],
    induction: ['theiere-induction'],
    electrique: ['theiere-electrique'],
    nomade: ['theiere-nomade'],
    japonaise: ['theiere-japonaise'],
    chinoise: ['theiere-chinoise'],
    matcha: ['accessoire-matcha'],
    service: ['service-a-the'],
  };

  const dataEl = document.getElementById('quiz-products-data');
  let allProducts = [];
  try {
    allProducts = JSON.parse(dataEl.textContent || '[]');
  } catch (e) {
    console.error('[quiz] Erreur parsing products data:', e);
  }

  const state = {
    currentStep: 1,
    totalSteps: 5,
    scores: {},
    budget: null,
    needsInduction: false,
    volume: null,
  };

  function updateProgress() {
    const pct = (state.currentStep / state.totalSteps) * 100;
    document.getElementById('quiz-progress-bar').style.width = pct + '%';
    document.getElementById('quiz-step-indicator').textContent = `Étape ${state.currentStep} / ${state.totalSteps}`;
  }

  function showStep(step) {
    document.querySelectorAll('.quiz-step').forEach(s => s.classList.remove('quiz-step--active'));
    const target = document.querySelector(`.quiz-step[data-step="${step}"]`);
    if (!target) return;
    target.classList.add('quiz-step--active');
    // Pas de scroll sur les transitions d'étapes (évite le saut de page).
    // On ne recadre en douceur QUE si le haut du quiz est sorti de l'écran
    // vers le haut (l'utilisateur a scrollé en dessous), et uniquement pour
    // le récap final qui est plus long.
    if (step === 'result') {
      const wrap = document.getElementById('quel-theiere-quiz');
      if (wrap) {
        const top = wrap.getBoundingClientRect().top;
        if (top < 0) {
          const y = window.pageYOffset + top - 24;
          window.scrollTo({ top: y, behavior: 'smooth' });
        }
      }
    }
  }

  function applyAnswer(btn) {
    const points = btn.getAttribute('data-points');
    if (points) {
      try {
        const parsed = JSON.parse(points);
        for (const [k, v] of Object.entries(parsed)) {
          state.scores[k] = (state.scores[k] || 0) + v;
        }
      } catch (e) { console.error('[quiz] points parse error', e); }
    }
    const budget = btn.getAttribute('data-budget');
    if (budget) state.budget = budget;
    const needsInd = btn.getAttribute('data-needs-induction');
    if (needsInd === 'true') state.needsInduction = true;
    const volume = btn.getAttribute('data-volume');
    if (volume) state.volume = volume;
  }

  function pickRecommendations() {
    // Tri des collections par score
    const sortedCollections = Object.entries(state.scores)
      .sort((a, b) => b[1] - a[1])
      .map(([k]) => k);

    // Pool produits : sélection des produits dans les collections gagnantes
    const seen = new Set();
    const pool = [];
    for (const colKey of sortedCollections) {
      const handles = COLLECTION_MAPPING[colKey] || [];
      for (const h of handles) {
        for (const p of allProducts) {
          if (p.collection === h && !seen.has(p.handle) && p.available) {
            seen.add(p.handle);
            pool.push({ ...p, scoreSource: colKey });
          }
        }
      }
    }

    // Filtre budget
    const range = PRICE_RANGES[state.budget] || PRICE_RANGES.premium;
    let filtered = pool.filter(p => p.price >= range.min && p.price <= range.max);

    // Si rien après filtre budget, prendre les moins chers du pool sans contrainte
    if (filtered.length === 0) {
      filtered = pool.slice().sort((a, b) => a.price - b.price);
    }

    // Filtre induction si choisi (mais ne pas être trop restrictif)
    if (state.needsInduction) {
      const inductionFirst = filtered.filter(p =>
        p.collection === 'theiere-induction' ||
        p.collection === 'theiere-inox' ||
        p.collection === 'theiere-electrique' ||
        /induction|inox|electrique/i.test(p.title)
      );
      const rest = filtered.filter(p => !inductionFirst.includes(p));
      filtered = inductionFirst.concat(rest);
    }

    return filtered.slice(0, 3);
  }

  function renderResults(recs) {
    const container = document.getElementById('quiz-result-cards');
    if (!container) return;
    container.innerHTML = '';

    if (recs.length === 0) {
      container.innerHTML = `<p style="text-align:center;color:#7a8765;grid-column:1/-1;padding:40px 20px;">Hmm, on n'a pas trouvé de match parfait avec ces critères. <a href="/collections/theiere" style="color:#546a2a;font-weight:600;">Voir toutes les théières →</a></p>`;
      return;
    }

    recs.forEach((p, i) => {
      const priceFr = (p.price / 100).toFixed(2).replace('.', ',') + ' €';
      const compare = p.compareAtPrice > p.price
        ? `<span class="quiz-card__compare">${(p.compareAtPrice / 100).toFixed(2).replace('.', ',')} €</span>`
        : '';
      const minidesc = p.minidesc ? `<p class="quiz-card__minidesc">${p.minidesc}</p>` : '';
      const card = document.createElement('a');
      card.className = 'quiz-card';
      card.href = p.url;
      card.innerHTML = `
        <div class="quiz-card__image-wrap">
          <span class="quiz-card__rank">${i === 0 ? '★ Top match' : '#' + (i + 1)}</span>
          <img class="quiz-card__image" src="${p.image}" alt="${escapeHtml(p.title)}" loading="lazy">
        </div>
        <div class="quiz-card__body">
          <h3 class="quiz-card__title">${escapeHtml(p.title)}</h3>
          ${minidesc}
          <div class="quiz-card__price-row">
            <span class="quiz-card__price">${priceFr}</span>
            ${compare}
          </div>
          <span class="quiz-card__cta">Voir le produit</span>
        </div>
      `;
      container.appendChild(card);
    });

    // Personnalise le titre selon la collection gagnante
    const top = recs[0];
    const titleEl = document.getElementById('quiz-result-title');
    if (titleEl && top) {
      const colTitle = collectionLabel(top.collection);
      titleEl.textContent = `Ta théière idéale : ${colTitle}`;
    }
  }

  function collectionLabel(handle) {
    const map = {
      'theiere-en-fonte': 'la fonte traditionnelle',
      'theiere-en-verre': 'le verre transparent',
      'theiere-ceramique': 'la céramique artisanale',
      'theiere-en-porcelaine': 'la porcelaine fine',
      'theiere-inox': "l'inox durable",
      'theiere-induction': "l'induction compatible",
      'theiere-electrique': "l'électrique programmable",
      'theiere-nomade': 'la nomade pratique',
      'theiere-japonaise': 'la tradition japonaise',
      'theiere-chinoise': "l'art chinois du thé",
      'accessoire-matcha': 'la cérémonie du matcha',
      'service-a-the': 'le service complet',
    };
    return map[handle] || 'la sélection Mamie';
  }

  function escapeHtml(s) {
    if (s == null) return '';
    return String(s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;').replace(/'/g, '&#39;');
  }

  function nextStep() {
    if (state.currentStep < state.totalSteps) {
      state.currentStep++;
      updateProgress();
      showStep(state.currentStep);
    } else {
      // Final step -> compute & show result
      const recs = pickRecommendations();
      renderResults(recs);
      showStep('result');
      // Push GA4 event si dispo
      try {
        if (window.dataLayer) {
          window.dataLayer.push({
            event: 'quiz_theiere_complete',
            scores: state.scores,
            budget: state.budget,
            top_recommendation: recs[0]?.handle || null,
          });
        }
      } catch (e) {}
    }
  }

  function restartQuiz(e) {
    if (e) e.preventDefault();
    state.currentStep = 1;
    state.scores = {};
    state.budget = null;
    state.needsInduction = false;
    state.volume = null;
    updateProgress();
    showStep(1);
  }

  // === Event handlers ===
  document.addEventListener('click', function (e) {
    const btn = e.target.closest('.quiz-answer');
    if (btn) {
      applyAnswer(btn);
      nextStep();
      return;
    }
    const restart = e.target.closest('#quiz-restart');
    if (restart) {
      restartQuiz(e);
    }
  });

  // Init
  updateProgress();
})();
